import {createDefaultLogger} from '@hconnect/common/logging'

export const HProduceSuiteLogger = createDefaultLogger('suite')
